import React from "react";
import { Modal, Table, Tag, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faUser, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const { Text, Title } = Typography;

export default function FileDetailsModal({ isOpen, onClose, files, project, month }) {
  const filesWithUser = files.filter((f) => f.participante).length;
  const filesWithoutUser = files.length - filesWithUser;

  const columns = [
    {
      title: "Archivo",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FontAwesomeIcon icon={faFileLines} style={{ color: "#888", fontSize: 14 }} />
          <Text ellipsis style={{ width: 220 }} title={record.name}>
            {record.name}
          </Text>
        </div>
      ),
    },
    {
      title: "Usuario",
      key: "usuario",
      render: (_, record) =>
        record.participante ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faUser} style={{ color: "#009728", fontSize: 14 }} />
            <Text>{record.participante.nombre_participante}</Text>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#FAAD14", fontSize: 14 }} />
            <Text type="secondary">Sin usuario</Text>
          </div>
        ),
    },
    {
      title: "Cédula",
      render: (_, record) =>
        record.cedula ? (
          <Text code>{record.cedula}</Text>
        ) : (
          <Text type="secondary">N/A</Text>
        ),
    },
    {
      title: "Estado",
      key: "status",
      render: (_, record) =>
        record.participante ? (
          <Tag color="#009728" style={{ color: "white" }}>
            Asignado
          </Tag>
        ) : (
          <Tag color="#FAAD14" style={{ color: "white" }}>
            Pendiente
          </Tag>
        ),
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1000}
      bodyStyle={{ maxHeight: "75vh", overflowY: "auto" }}
    >
      <Title level={4}>
        Archivos — {project} — {month}
      </Title>

      <Text type="secondary">
        Total: {files.length} archivos | Con usuario: {filesWithUser} | Sin usuario:{" "}
        {filesWithoutUser}
      </Text>

      <div style={{ marginTop: 20 }}>
        <Table
          columns={columns}
          dataSource={files}
          rowKey={(record, index) => record.path + "-" + index}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>
    </Modal>
  );
}
